var map = {
	"./book.jpg": 832,
	"./bri.jpg": 805,
	"./burger.jpg": 746,
	"./cabbageroll.jpg": 160,
	"./cake.jpg": 163,
	"./cucumbersalad.jpg": 227,
	"./dosa.jpg": 990,
	"./ginger.jpg": 786,
	"./newscomp.jpg": 654,
	"./newscomp2.jpg": 981,
	"./pizza.jpg": 157,
	"./spaghetti.jpg": 169,
	"./yumyum.jpg": 399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;